<ng-container *transloco="let t">
    <!--
        Live toast stack. `aria-live="polite"` announces each arriving toast without
        stealing focus; the layer itself is pointer-transparent so only the cards
        intercept clicks (see .sai-toast-layer in _sai-components.scss).
    -->
    <div
        *ngIf="toasts.length"
        class="sai-toast-layer"
        role="region"
        aria-live="polite"
        aria-relevant="additions"
        [attr.aria-label]="t('Notifications')"
    >
        <div
            *ngFor="let toast of toasts; trackBy: trackByToast"
            class="sai-toast"
            [class.sai-toast--leaving]="isLeaving(toast)"
            [class.sai-toast--paused]="isPaused(toast)"
            (mouseenter)="pause(toast)"
            (mouseleave)="resume(toast)"
            (focusin)="pause(toast)"
            (focusout)="resume(toast)"
        >
            <div class="sai-toast__row">
                <!-- The whole body is one button so the toast is clickable and keyboard-operable. -->
                <button
                    type="button"
                    class="sai-toast__main"
                    [disabled]="!toast.actionable"
                    (click)="activate(toast)"
                >
                    <span class="sai-toast__icon" [ngClass]="toast.iconBgClass">
                        <mat-icon
                            class="icon-size-5"
                            [ngClass]="toast.iconTextClass"
                            [svgIcon]="toast.icon"
                        ></mat-icon>
                    </span>

                    <span class="sai-toast__text">
                        <span class="sai-toast__title" [innerHTML]="toast.title"></span>
                        <span
                            *ngIf="toast.body"
                            class="sai-toast__body"
                            [innerHTML]="toast.body"
                        ></span>
                        <span *ngIf="toast.actionable" class="sai-toast__cta">
                            {{ t('View') }}
                            <mat-icon
                                class="sai-toast__cta-arrow icon-size-4"
                                [svgIcon]="'heroicons_mini:arrow-right'"
                            ></mat-icon>
                        </span>
                    </span>
                </button>

                <button
                    type="button"
                    mat-icon-button
                    class="sai-toast__close"
                    [matTooltip]="t('Dismiss notification')"
                    [attr.aria-label]="t('Dismiss notification')"
                    (click)="dismiss(toast)"
                >
                    <mat-icon class="icon-size-4" [svgIcon]="'heroicons_mini:x-mark'"></mat-icon>
                </button>
            </div>

            <!-- Time-remaining bar. Shares the countdown's pause state via .sai-toast--paused. -->
            <div class="sai-toast__progress">
                <div
                    class="sai-toast__progress-fill"
                    [style.animation-duration.ms]="toast.duration"
                ></div>
            </div>
        </div>
    </div>
</ng-container>
